import config from "../../../config";

const defParams = {
    percent: {
        style: 'percent',
        minimumFractionDigits: config.percentDecimalFixedValue,
        maximumFractionDigits: config.percentDecimalFixedValue
    },
    percentage: {
        style: 'percent'
    },
    currencyPlacement: {
        HUF: 'suffix',
        JPY: 'prefix',
        MATRIX: 'suffix',
    },
    currencySymbols: {
        BTC: '₿',
        XBT: '฿',
        mXBT: 'm฿',
        ETH: 'Ξ',
        USDT: '₮',
        MATRIX: 'Ⓜ',
    },
    currency: {
        default: {
            style: 'currency'
        },
        USD: {
            minimumFractionDigits: 4
        },
        EUR: {
            minimumFractionDigits: 4
        },
        UST: {
            minimumFractionDigits: 4
        },
        RON: {
            minimumFractionDigits: 4
        },
        UAH: {
            minimumFractionDigits: 4
        },
        INR: {
            minimumFractionDigits: 4
        }
    },
    currencyBalance: {
        default: {
            style: 'currency'
        },
        USD: {
            minimumFractionDigits: 2
        },
        EUR: {
            minimumFractionDigits: 2
        },
        UST: {
            minimumFractionDigits: 2
        },
        RON: {
            minimumFractionDigits: 2
        },
        UAH: {
            minimumFractionDigits: 2
        },
        INR: {
            minimumFractionDigits: 2
        }
    },
    date: {},
    dateTime: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    },
    fullDateTime: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    },
    dateMonth: {
        year: 'numeric',
        month: 'long'
    },
    dateYear: {
        year: 'numeric'
    },
    int: { maximumFractionDigits: 0 },
    dateShort: { year: 'numeric', month: 'short', day: '2-digit' },
};

export default defParams;
